import apiService from '@/api/apiService';

export const deleteVersion = async (id) => {
    const url = `/api/admin/balance/version/${id}`;

    return apiService.DELETE(url);
};
